import React from 'react';
import styled from 'styled-components';

import { PrimaryButton } from '@ad-scripts/presentation/components/common/button';

type ErrorFallbackProps = {
  resetError: Function;
};

const ErrorFallback = ({ resetError }: ErrorFallbackProps) => {
  return (
    <Container data-aid="error-boundary-container">
      <Row>
        <Item data-aid="error-boundary-message">
          <p>Something went wrong!</p>
          <p>Please refresh or come back at a later time</p>
        </Item>
        <Item>
          <PrimaryButton
            data-aid="error-boundary-button"
            onClick={() => {
              resetError();
              window.location.reload();
            }}
          >
            Reload
          </PrimaryButton>
        </Item>
      </Row>
    </Container>
  );
};

const Container = styled.div`
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 100vw;
`;

const Row = styled.div`
  width: auto;
`;

const Item = styled.div`
  padding: 5px;
  text-align: center;
`;

export default ErrorFallback;
